import React from 'react';
import { styled } from '@linaria/react';

interface Props extends React.SVGProps<SVGLineElement> {
  isActive?: boolean;
  isHidden?: boolean;
}

function GuideLine({
  isActive = false,
  isHidden = false,
  ref,
  ...delegated
}: Props) {
  return (
    <>
      <GuideLineBackground data-is-active={isActive} {...delegated} />
      <GuideLineForeground data-is-active={isActive} {...delegated} />
    </>
  );
}

export const GuideLineBase = styled.line`
  stroke: white;
  stroke-width: 2px;
  stroke-dasharray: 4 6;
  stroke-linecap: round;
  transition:
    stroke-dasharray 500ms,
    stroke-dashoffset 500ms;

  &[data-is-active='true'] {
    stroke-dasharray: 10 0;
    stroke-dashoffset: 3;
    transition:
      stroke-dasharray 200ms,
      stroke-dashoffset 200ms;
  }
`;

export const GuideLineForeground = styled(GuideLineBase)`
  &[data-is-active='true'] {
    stroke: var(--wham-primary-500);
  }
`;

export const GuideLineBackground = styled(GuideLineBase)`
  stroke: var(--color-background);
  stroke-width: 5px;
`;

export default GuideLine;
